import configdata from "../../config.json";
import { cartoonStockSliceAction } from "./CartoonStockSlice";
import { getApi } from "../BaseApi";
import { getOnlyValueFromSelectObject } from "../UseAbleFun";
import { appLevelSliceActions } from "../AppLevelApi/AppLevelSlice";
export const getAllCartoonStocksItems = () => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-stocks`
    );

    // dispatch(appLevelSliceActions.setLoadingState());

    // dispatch(
    //   cartoonStockSliceAction.getAllCartoonStocks(res.data.cartoonStock)
    // );
  };
};
export const createCartoonStockItem = (
  data,
  duplicateData,
  createOrAddMore
) => {
  let newDuplicateData = { ...duplicateData };

  const cartoonTypeList = newDuplicateData.cartoon_type.map((item) => {
    const value = item.value;
    return value;
  });

  newDuplicateData.cartoon_type = cartoonTypeList;

  data = { ...data, ...newDuplicateData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());

    let resurl = `${configdata.SERVER_URL}/api/cartoon-stocks/store`;

    let resData = await getApi("post", resurl, form);
    if (resData?.error) {
      if (resData?.errorType === "single") {
        // dispatch(
        //   appLevelSliceActions.setError({ msg: resData.message, isError: true })
        // );
      } else {
        // dispatch(
        //   cartoonStockSliceAction.setErrorData({
        //     message: resData.message,
        //     isError: true,
        //   })
        // );
      }

      // dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    // dispatch(
    //   cartoonStockSliceAction.setErrorData({
    //     message: {},
    //     isError: false,
    //   })
    // );
    // dispatch(appLevelSliceActions.setIsSuccess(true));
    // dispatch(cartoonStockSliceAction.setInitialData());
    // dispatch(cartoonStockSliceAction.setDuplicateInitialData());
    // dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    // dispatch(getAllCartoonStocksItems());
  };
};
export const getDataForEdit = (id, qualityList) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-stocks/edit/${id}`
    );

    // dispatch(appLevelSliceActions.setLoadingState());
    const data = { ...res.data.cartonStock[0] };

    const quality = qualityList.find((item) => {
      return item.value === data.quality_id;
    });

    data.quality = {
      value: quality.value,
      label: quality.label,
      type: quality.type,
    };
    data.status = {
      value: `${data.status}`,
      label: data.status === "active" ? "Active" : "Deactive",
      type: "status",
    };
    data.discount_type = {
      value: `${data.discount_type}`,
      label: data.discount_type === "flat" ? "Flat" : "%",
      type: "discount_type",
    };

    // dispatch(cartoonStockSliceAction.getCartoonStockDataEdit(data));
  };
};

export const adjustCartoonStockItem = (data, adjustedData, duplicateData) => {
  const newDuplicateData = { ...duplicateData };
  const cartoonTypeList = duplicateData.cartoon_type.map((item) => {
    const value = item.value;
    return value;
  });
  newDuplicateData.cartoon_type = cartoonTypeList;

  data = { ...data, ...newDuplicateData, ...adjustedData };
  // data.push({ ...newDuplicateData });
  const { form } = getOnlyValueFromSelectObject(data);

  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const resData = await getApi(
      "post",
      `${configdata.SERVER_URL}/api/cartoon-stocks/update/${data.id}`,
      form
    );

    if (resData?.error) {
      if (resData?.errorType === "single") {
        // dispatch(
        //   appLevelSliceActions.setError({ msg: resData.message, isError: true })
        // );
      } else {
        // dispatch(
        //   cartoonStockSliceAction.setErrorData({
        //     message: resData.message,
        //     isError: true,
        //   })
        // );
      }

      // dispatch(appLevelSliceActions.setLoadingState());
      return;
    }
    // dispatch(
    //   cartoonStockSliceAction.setErrorData({
    //     message: {},
    //     isError: false,
    //   })
    // );
    // dispatch(appLevelSliceActions.setIsSuccess(true));
    // dispatch(cartoonStockSliceAction.setInitialData());
    // dispatch(cartoonStockSliceAction.setDuplicateInitialData());
    // dispatch(appLevelSliceActions.setLoadingState());
    window.location.reload(false);
    // dispatch(getAllCartoonStocksItems());
  };
};

export const deleteCartoonStockItem = (id) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-stocks/delete/${id}`
    );
    // dispatch(appLevelSliceActions.setIsSuccess(true));
    // dispatch(appLevelSliceActions.setLoadingState());
  };
};

export const getBillListForVendor = (id) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-stocks/show/${id}`
    );
    // dispatch(appLevelSliceActions.setLoadingState());
    const data = res.data.data.map((item) => {
      return { value: item, label: item, type: "bill_number" };
    });
    if (data.length > 0) {
      // dispatch(cartoonStockSliceAction.getBillList({ data: data }));
    } else {
      // dispatch(cartoonStockSliceAction.getBillList({ data: [] }));
    }
  };
};

export const getDataForAfterBill = (billNumber) => {
  return async (dispatch) => {
    // dispatch(appLevelSliceActions.setLoadingState());
    const res = await getApi(
      "get",
      `${configdata.SERVER_URL}/api/cartoon-stocks/edit/${billNumber}`
    );
    // dispatch(appLevelSliceActions.setLoadingState());
    const quantities = [];
    const pricePerCartoon = [];
    const type = [];
    let arrayLength = 0;
    res.data.data.forEach((item) => {
      quantities.push(item.quantity);
      pricePerCartoon.push(item.price_per_cartoon);
      type.push({
        value: item.name,
        label: item.name,
        type: "cartoon_type",
      });
      arrayLength = arrayLength + 1;
    });
    const data = {
      quantity: quantities,
      price_per_cartoon: pricePerCartoon,
      cartoon_type: type,
      arrayLength: arrayLength,
    };
    const otherDataWithOutArray = {
      id: parseInt(res.data.data[0].type_id),
      purchase_date: res.data.data[0].purchase_date,
      paid_amount: res.data.data[0].paid_amount,
      total_amount: res.data.data[0].total_amount,
    };

    // dispatch(
    //   cartoonStockSliceAction.getDataUsingBill({
    //     data: data,
    //     editData: otherDataWithOutArray,
    //   })
    // );
  };
};
